import styles from "./taskcard.module.css";
import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { Check, ChevronRight, Edit2 } from "react-feather";
import TaskForm from "./TaskForm";
import { Checkbox, FormControlLabel } from "@mui/material";

const TaskCard = ({ item, index, setAllData, activeAccordion, setActiveAccordion, setLoading, isSecondary, currentUserId }) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [tasks, setTasks] = useState({ completed: 0, total: 0 });
  const [activeItem, setActiveItem] = useState(null);

  const isActive = activeAccordion === index;

  const toggle = () => {
    setActiveAccordion(isActive ? null : index);
  }

  useEffect(() => {
    let completedTask = item?.today_check_list?.filter((i) => i?.is_checked === 1);
    setTasks({ completed: completedTask?.length, total: item?.today_check_list?.length });
  }, [item]);

  const saveAnswer = async (data, task) => {
    setLoading(true);

    let newItem = item?.today_check_list?.map((i) => {
      if (i?.id === task?.id)
        return { ...i, is_checked: 1 };
      return i;
    });

    setAllData((prev) => {
      return prev?.map((i) => {
        if (i?.id === item?.id) return { ...i, today_check_list: newItem };
        return i;
      });
    });

    let newData = { ...data, is_checked: 1 };

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.put(process.env.REACT_APP_CASE_API_URL + "v1/check-list/" + task?.id, newData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(() => {
      setLoading(false);
      setActiveItem(null);

      let logData = {
        title: "A task has been checked.",
        description: [
          "Task Name: " + task.task_list,
          "List Name: " + item.title
        ],
      };

      AddLogCallAPI(logData, token);
    }).catch(() => {
      setLoading(false);
    });
  }

  return (<div className={styles.AccordionSecMain}>
    <div className={`${styles.AccordionList}`} key={item?.id}>
      <div className={`${styles.AccordionListHead} ${isActive ? styles.Open : ""}`} onClick={() => toggle(index)}>
        <div>
          <p className={`${styles.Title}`}>
            <span>Task Name</span>
            {item?.title}
          </p>
          <p className={`${styles.SubTitle}`}>
            <span>Completed Tasks</span>
            {tasks?.completed}/{tasks?.total}
            {tasks?.completed < tasks?.total && (<img src="/static/img/warning.png" className={`${styles.StatusIMG}`} alt="warning" />)}
            {tasks?.completed === tasks?.total && (<img src="/static/img/success.png" className={`${styles.StatusIMG}`} alt="Completed" />)}
          </p>
          <img src="/static/img/downTriangle.svg" alt="" />
        </div>
        <p className={`${styles.FrequencyText}`}>
          {item?.days?.map((d) => d.slice(0, 3)).join(", ")}
        </p>
      </div>
      <div className={`${styles.AccordionListBody} ${isActive ? styles.Open : ""}`}>
        {item?.today_check_list.map((task, index) => (<>
          <div key={task.id} className={activeItem === index ? `${styles.TaskCheckList} ${styles.Active}` : `${styles.TaskCheckList}`}>
            <div className={`${styles.TaskCheckListHead}`} onClick={() => {
              if (!(isSecondary === 1 && task.is_checked && task.checked_by !== parseInt(currentUserId)))
                setActiveItem((prev) => (prev === index ? null : index));
            }}>
              <FormControlLabel
                className={`${styles.ProsCheckSec}`}
                control={<Checkbox
                  checked={!!task.is_checked}
                  disabled={(!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task-checklist:update") > -1))}
                />}
              />
              <div className={`${styles.TaskTitleSec}`}>
                <p className={`${styles.Title}`}>{task.is_checked ? (<del>{task.task_list}</del>) : (task.task_list)}</p>
                {/* {task.is_checked === 1 ? <>
                  <div className={`${styles.TaskPreview}`}>
                    <span className={`${styles.StatusBadgeANS}`}><Check /> Answered</span>
                    <span className={`${styles.StatusAnsText}`}>View answer</span>
                  </div>
                  <ChevronRight className={`${styles.TaskDeIcon}`} />
                </> : <>
                  <div className={`${styles.TaskPreview}`}>
                    <span className={`${styles.StatusBadge}`}>Question</span>
                    <span className={`${styles.StatusAnsText}`}>Tap to answer</span>
                  </div>
                  <ChevronRight className={`${styles.TaskDeIcon}`} />
                </>} */}
              </div>
              {task.is_checked === 1 ? <>
                <button className={`${styles.AnswerBu}`}><Check /> Answered</button>
              </> : <>
                <button className={`${styles.AnswerBu}`}><Edit2 /> Answer</button>
              </>}
            </div>

            <div className={`${styles.TaskAnsSec}`}>
              <TaskForm task={task} saveAnswerConf={saveAnswer.bind(this)} date={null} />
            </div>

          </div>
        </>))}
      </div >
    </div>
  </div>);
};

export default TaskCard;